import { GuiListAktion } from "./GuiListAktion";

export class GuiListAktionMobil extends GuiListAktion {
}
